import React, {InputHTMLAttributes} from 'react';
import {mergeClassnames} from '../../../utils';
import full from './InputText.full.module.scss';
import secondary from './InputText.secondary.module.scss';

type InputVariant = 'full' | 'secondary';
type ComponentCustomClassnames = {
  container: string,
  filledInputContainer: string,
  label: string,
  inputContainer: string,
  input: string,
  errorContainer: string,
  error: string
};
export interface InputComponentProps extends InputHTMLAttributes<HTMLInputElement> {
  id: string,
  label?: React.ReactNode,
  value?: string,
  error?: string,
  touched?: boolean,
  type?: string,
  maxlength?: string,
  showErrorOnSubmit?: boolean
}
export interface StylesInputComponentProps extends InputComponentProps {
  customClassnames: ComponentCustomClassnames
}
export interface InputTextProps extends InputComponentProps {
  variant?: InputVariant,
  customClassnames?: Partial<ComponentCustomClassnames>;
}

const InputTextComponent = ({
                              id,
                              label,
                              value,
                              error,
                              touched,
                              customClassnames,
                              placeholder,
                              type = 'text',
                              showErrorOnSubmit,
                              ...rest
                            }: StylesInputComponentProps) => {
  const showErrorCondition = !!error && (showErrorOnSubmit || (touched && (!value || error)));

  return (
    <div className={customClassnames.container}>
      <div className={customClassnames.inputContainer}>
        <input
          id={id}
          type={type}
          value={value}
          className={customClassnames.input}
          placeholder={placeholder}
          {...rest}
        />
        {label && (
          <label htmlFor={id} className={customClassnames.label}>
            {label}
          </label>
        )}
      </div>
      <div className={customClassnames.errorContainer}>
        {showErrorCondition && (
          <div className={customClassnames.error}>{error}</div>
        )}
      </div>
    </div>
  );
};

const InputText = ({
                     variant = 'full',
                     customClassnames = {},
                     ...rest
                   }: InputTextProps) => {
  switch (variant) {
    case 'secondary':
      return (
        <InputTextComponent
          customClassnames={mergeClassnames(secondary, customClassnames) as ComponentCustomClassnames}
          {...rest}
        />
      );
    case 'full':
    default:
      return (
        <InputTextComponent
          customClassnames={mergeClassnames(full, customClassnames) as ComponentCustomClassnames}
          {...rest}
        />
      );
  }
};

export default InputText;
